var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOobcCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7778 26.7589L27 22.5443V9.90067L14.7778 14.1152L5 8.21484V20.8585L14.7778 26.7589Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.21456L17.2222 4L27 9.90038",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7754 14.1133V26.757",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9982 22.5449L17.2205 16.6445",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1 1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.8582L17.2222 16.6437V12.0077V4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOobcCube);
export default __webpack_public_path__ + "static/media/ic_OOBC_cube.1dfea8f485a34444f5a5b5f9db34cc9a.svg";
export { ForwardRef as ReactComponent };